import React from "react";
import RichText from "components/rich-text";
import CustomRichText from "components/rich-text/custom";
import Image from "components/image";
import Link from "components/link";
import clsx from "clsx/lite";
import { getButtonStyle } from "helpers/get-button-style";

const PromoCard = ({ data, className }) => {
	const { image, saleBanner, url, title, description, additionalInfo, button } = data || {};

	return (
		<Link to={url} className={clsx(className, "promo-card", saleBanner && "sale-banner")}>
			<div className="relative w-full h-full flex-grow overflow-hidden">
				<Image image={image} className="w-full h-full *:!object-fill" />
				<div className="promo-card-container">
					{title &&
						<div className="promo-card-title">
							<CustomRichText data={title} />
						</div>
					}
					{description &&
						<div className="promo-card-description">
							<RichText data={{ content: description }} />
						</div>
					}
					{additionalInfo && <div className="promo-card-additional-info">
						<RichText data={{ content: additionalInfo }} />
					</div>
					}
					{button?.text &&
						<div className={clsx(getButtonStyle(button.style, button.size),
							"w-full px-2 text-[8px] sm500:text-xs sm:text-sm sm:mt-2")} >
							{button.text}
						</div>}
				</div>
			</div>
		</Link>
	);
};

export default PromoCard;